import { Skeleton } from "@workith/ui";

// 문서/폴더 카드 그리드 로딩 상태. 각 페이지의 실제 카드 그리드와 동일한 브레이크포인트를 사용한다.
export function DocumentGridSkeleton() {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3 lg:grid-cols-4">
      {[0, 1, 2, 3].map((i) => (
        <Skeleton key={i} className="h-28" />
      ))}
    </div>
  );
}
